import React from "react";
import { motion } from "framer-motion";
import "./heroTrust.css";

import aboutImage from "../../assets/Gemini_Generated_Image_6spchl6spchl6spc.png"; // use your actual image

const HeroTrust: React.FC = () => {
  return (
    <section className="home-about" aria-labelledby="home-about-title">
      <div className="home-about__container">
        {/* LEFT CONTENT */}
        <motion.div
          className="home-about__left"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <span className="about-chip">ABOUT US</span>

          <h2 id="home-about-title" className="home-about__title">
            The Bridge Between{" "}
            <span className="accent">Semiconductor</span> Engineering &{" "}
            <span className="accent">Enterprise IT</span>
          </h2>

          <p className="home-about__text">
            Nordic Integration Works is a specialist consulting and recruitment
            company operating at the intersection of semiconductor engineering
            and SAP/IT services, supporting organizations with deep expertise,
            innovation, and reliable delivery.
          </p>

          {/* STATS */}
          <div className="home-about__stats">
            <div className="stat">
              <div className="stat-icon">▦</div>
              <span>50+ years combined industry experience</span>
            </div>
            <div className="stat">
              <div className="stat-icon">▦</div>
              <span>Senior-only consultants</span>
            </div>
            <div className="stat">
              <div className="stat-icon">▦</div>
              <span>Trusted by global telecom leaders</span>
            </div>
            <div className="stat">
              <div className="stat-icon">▦</div>
              <span>Semiconductor • AI • SAP/IT</span>
            </div>
          </div>

          <a href="/about-us" className="about-link">
            Learn more about us →
          </a>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="home-about__right"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <div className="image-card">
            <img src={aboutImage} alt="Nordic Integration Works team" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroTrust;
